'use client';

import React, { useRef, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './custom_scrollbar.css';
import { SENATE, TITAN_WHITE } from '@/constants';
import { cn } from '@/utils/cn';
import { sliderMainClassTypes, sliderNavigationTypes } from '@/constants/types';
import Icon from '@/app/components/Icon';
import ProductCardV2 from '../Card/ProductCardV2';
import SliderWrapper from '../Wrapper/SliderWrapper';
import SliderGridProductCardSkeleton from '../Skeleton/SliderGridProductCardSkeleton';

function FrequentlyBoughtSlider({ items = [], isLoading }) {
  const [arrowPrevColor, setArrowPrevColor] = useState(SENATE);
  const [arrowNextColor, setArrowNextColor] = useState(SENATE);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <SliderWrapper
      outerDivClass="h-auto mb-24 lg:mb-48 relative"
      containerRefClass={cn('container mx-auto')}
      sliderMainClassType={sliderMainClassTypes.justForYou}
      sliderNavigationType={sliderNavigationTypes.withNavigation}
      prevButtonRef={prevRef}
      nextButtonRef={nextRef}
    >
      {isLoading ? (
        <SliderGridProductCardSkeleton />
      ) : (
        items?.length > 0 &&
        items?.map((item) => (
          <SwiperSlide
            key={item.id}
            className="w-full max-w-[180px] lg:max-w-[298px]"
          >
            <ProductCardV2 key={item.id} data={item} />
          </SwiperSlide>
        ))
      )}
      {/* navigation button */}
      <div
        ref={prevRef}
        className="swiper-button-prev !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowPrevColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowPrevColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowPrevColor}
          className="!w-[24px] !h-[24px] -rotate-180"
        />
      </div>
      <div
        ref={nextRef}
        className="recently-viewed-slider swiper-button-next !right-0 !flex justify-center items-center !w-[36px] !h-[36px] bg-titanwhite rounded-full shadow-product-slider-shadow"
        onMouseEnter={() => setArrowNextColor(TITAN_WHITE)}
        onMouseLeave={() => setArrowNextColor(TITAN_WHITE)}
      >
        <Icon
          type="angle-right2"
          color={arrowNextColor}
          className="!w-[24px] !h-[24px]"
        />
      </div>
    </SliderWrapper>
  );
}

export default FrequentlyBoughtSlider;
